export default __webpack_public_path__ + "static/media/icLockTest.0f928d74.svg";